export const environment = {
    //apiOrigin: "https://themis-api.msos.org.uk/api",
    apiOrigin: "https://demo-api.msos.org.uk/api",
    clientId: "A721C377-7636-4CBE-A573-50D2DAFFF740",
	production: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts